import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";



//OBTIENE LOS PERMISOS GENERALES
export const getPermisosGenerales = async () => {
    const respuesta = await PrivateInterceptor(`Base/Global/PermisosGenerales`, "GET");
    return respuesta;
  };

// GUARDAR PERMISO GENERAL
export const GuardarPermisoGeneral = (Datos) => {
    const respuesta = PrivateInterceptor("Base/Global/PermisosGenerales/GuardarPermisoGeneral", "POST", {Datos});
    return respuesta;
};

// GUARDAR PERMISO GENERAL
export const EditarPermisoGeneral = (Datos) => {
  const respuesta = PrivateInterceptor("Base/Global/PermisosGenerales/EditarPermisoGeneral", "POST", {Datos});
  return respuesta;
};